module.exports = __webpack_public_path__ + "static/media/customer-icon-footer.71bafc3c.svg";